import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ServerErrorDialogService } from '../../../shared/services/server-error-dialog.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private serverErrorDialog: ServerErrorDialogService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status >= 500 && error?.status < 600) {
          if (this.shouldSuppressDialog(req.url)) {
            return throwError(() => error);
          }
          const backendMessage = this.extractBackendMessage(error);
          this.serverErrorDialog.showServerError(backendMessage);
        }
        return throwError(() => error);
      })
    );
  }

  private shouldSuppressDialog(url: string | null | undefined): boolean {
    if (!url) {
      return false;
    }
    return url.includes('/instrumentIO/upload/instrumentcsv/')
      || url.includes('/referenceIO/upload/referencedata/');
  }

  private extractBackendMessage(error: HttpErrorResponse): string {
    const errorBody = error?.error;
    if (!errorBody) {
      return error.message || 'Server error occurred.';
    }

    if (typeof errorBody === 'string') {
      return errorBody;
    }

    if (typeof errorBody === 'object') {
      const message = (errorBody as { detail?: string; message?: string; error?: string }).detail
        || (errorBody as { message?: string }).message
        || (errorBody as { error?: string }).error;
      if (message) {
        return message;
      }
    }

    return error.message || 'Server error occurred.';
  }
}
